module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/18IdK9a/tc-custom/9781439653043.jpg?1688985130100",
      "alt": "This image is the cover for the book Kingsport Speedway, Images of Sports"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Kingsport Speedway, Images of Sports\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Kingsport Speedway has hosted many of racing's greatest drivers, whether its track surface was asphalt, red clay, or brushed concrete. The short track, located in East Tennessee, has undergone dramatic changes since 1965 in attempts to keep pace with an ever-evolving motorsports landscape while entertaining three generations of fans. Hall of Fame members have raced and won at Kingsport Speedway, as did a contingent of regional stars. Today, Kingsport Speedway features weekly programs of NASCAR's Whelen All-American Series, which crowns track, state, regional, and national champions.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      David M. McGee\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("David M. McGee is the senior announcer at Bristol Motor Speedway and Dragway. He is the author of four books about motorsports in East Tennessee and an award-winning journalist at the Bristol Herald Courier. The images for this book came from the author, local historians, and several motorsports photographers, including track photographer Randall Perry.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0